module.exports = __webpack_public_path__ + "media/BS_Start_Mobile_Korr.781fa4ec.mp4";